import { config as currentRefinements } from './currentRefinements.js';
import { config as clearRefinements } from './clearRefinements.js';
import { config as pagination } from './pagination.js';
import { config as hits } from './hits.js';
import { config as searchBox  } from './searchBox.js';

export const configs = {
	pagination,
	clearRefinements,
	currentRefinements,
	searchBox,
	hits,
}
